import { Product } from "@~/types/types.ts";
import { useState } from "react";
import styles from "@~/product-card-components/QuickView/QuickView.module.scss";
import { IconButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/IconButton";
import { VisibleOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/VisibleOutlined";
import { QuickViewModal } from "@~/product-card-components/__shared__/QuickViewModal/QuickViewModal.tsx";

type Props = {
  product: Product;
  handleIconClick?: () => void;
};

export function QuickViewIcon({ product, handleIconClick }: Props) {
  const [showQuickView, setShowQuickView] = useState(false);

  const handleClick = () => {
    if (handleIconClick) {
      handleIconClick();
    }
    setShowQuickView(true);
  };

  return (
    <>
      <IconButton
        IconComponent={VisibleOutlined}
        ariaLabel={`Quick view for ${product.title}`}
        className={styles["quick-view-icon"]}
        onClick={handleClick}
        size="small"
        title={`Quick view`}
        data-testid="icon-quick-view-button"
      />
      {showQuickView && (
        <QuickViewModal
          product={product}
          showModal={true}
          onClose={() => setShowQuickView(false)}
          originator={"QUICK_VIEW_ICON"}
        />
      )}
    </>
  );
}
